var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-toolbar"},[_vm._t("title"),_c('div',{staticClass:"space"}),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }